exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.price-badge[data-v-edc3ebb6] {\r\n  position: absolute;\r\n  top: -16px;\r\n  transform: translateX(50%);\r\n  right: 50%;\r\n  border: 1px solid #d1bf89 !important;\r\n  background-color: #efe2b9 !important;\n}\n.text-shadow[data-v-edc3ebb6] {\r\n  text-shadow: 2px 2px 6px black;\n}\n.buy-button[data-v-edc3ebb6] {\r\n  width: 100%;\r\n  font-size: 1em;\r\n  height: 41px;\n}\r\n", ""]);

// exports
